import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchGroups = createAsyncThunk(
    "groups/fetchGroups",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/group", { params });
            const result = response.data;
            return {
                items: result?.data?.items || (Array.isArray(result?.data) ? result.data : result?.data?.groups || result?.groups || (Array.isArray(result) ? result : [])),
                pagination: result?.data?.pagination || null
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
